import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "as-tab-content"
}

import { ref, computed, watch } from "vue";
import type { IStatistics, IMatch } from "~src/interfaces";
// import { useRoute } from "vue-router";
import StatisticsItem from "~src/components/statistics/StatisticsItem.vue";
import NoData from "~src/components/NoData.vue";
import { getProcessedStats, initializeData } from "~src/helpers";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  statistics: IStatistics[];
  match: IMatch;
  isHomePage: boolean;
  isTabCenter?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StatisticsList',
  props: {
    statistics: {},
    match: {},
    isHomePage: { type: Boolean, default: false },
    isTabCenter: { type: Boolean, default: false }
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;
console.log(props.statistics);

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref(0);

const dataDefault = {
  stats: [
    {
      team_id: props.match.home_team_id,
      ball_possession: 50,
      corner_kicks: 0,
      yellow_cards: 0,
      red_cards: 0,
      shots_on_target: 0,
      shots_off_target: 0,
      dangerous_attack: 0,
    },
    {
      team_id: props.match.away_team_id,
      ball_possession: 50,
      corner_kicks: 0,
      yellow_cards: 0,
      red_cards: 0,
      shots_on_target: 0,
      shots_off_target: 0,
      dangerous_attack: 0,
    },
  ],
  id: "default",
  type: 5,
};

const statisticAll = computed<IStatistics>(() => {
  return props.statistics.find(
    (item: IStatistics) => item.type === 0
  ) as IStatistics;
});

const isShowTab = computed(() => {
  if (!statisticAll.value) {
    return false;
  }

  const stats = getProcessedStats(props.match, statisticAll.value, false);
  return stats.length > 0;
});

const getTabLabel = (type: number): string => {
  switch (type) {
    case 0:
      return "Tất cả";
    case 1:
      return "Hiệp 1";
    case 2:
      return "Hiệp 2";
    case 3:
      return "Hiệp Phụ 1";
    case 4:
      return "Hiệp Phụ 2";
    default:
      return "Unknown";
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      { 'as-statistic-home': _ctx.isHomePage },
      { 'as-tab-btn-center': _ctx.isTabCenter },
      `as-parent-statics as-parent-statics-${siteName.value}`,
    ])
  }, [
    (isShowTab.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["as-nav-tabs-btn as-nav-tabs-btn__border", `as-nav-tabs-btn-${siteName.value}`])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (tab) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tab.id,
              class: _normalizeClass(["as-nav-item", { active: activeTab.value === tab.type }]),
              onClick: ($event: any) => (activeTab.value = tab.type)
            }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "as-extra-item" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(getTabLabel(tab.type)), 1)
            ], 10, _hoisted_1))
          }), 128))
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(StatisticsItem, {
            statistics: dataDefault,
            match: _ctx.match,
            isHomePage: _ctx.isHomePage,
            isDefault: true
          }, null, 8, ["match", "isHomePage"])
        ])),
    (isShowTab.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (statistic) => {
            return _withDirectives((_openBlock(), _createBlock(StatisticsItem, {
              key: statistic.id,
              statistics: statistic,
              match: _ctx.match,
              isHomePage: _ctx.isHomePage
            }, null, 8, ["statistics", "match", "isHomePage"])), [
              [_vShow, activeTab.value === statistic.type]
            ])
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})